export default [
    // 补货周期
    {
        path:  "replenishmentcycle/list",
        name: "replenishmentCycle",
        component: () => import(/* */ "@/views/replenishmentcycle/index"),
    }
]